import CheckBox from 'src/assets/img/SalesForce_Icon/CheckBox.svg';
import { Col, Dropdown, Form, Menu, message } from 'antd';
import TextComponent from '@sharedComponent/typography/TextComponent';
import { DownOutlined, EnvironmentOutlined, SearchOutlined } from '@ant-design/icons';
import React, { useState, useEffect } from 'react';
const SalesForceCheckBox = ({ isChecked, text, onCheck }) => {
	const [selected, setSelected] = useState(false);

	useEffect(() => {
		setSelected(isChecked);
	}, []);

	console.log('sd23', text, isChecked);
	const checking = (value) => {
		console.log(value);
		// setSelected(value);
		onCheck(isChecked);
	};
	if (selected) {
		console.log('its on');
	}
	return (
		<>
			<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start' }}>
				<div style={{ width: '25px' }}>
					{isChecked ? (
						<img onClick={() => checking(false)} style={{ width: '25px', margin: '-5px' }} src={CheckBox}></img>
					) : (
						<input style={{ width: '15px', height: '15px' }} type="radio" onClick={() => checking(true)} />
					)}
				</div>
				<TextComponent className={isChecked ? 'option_text_selected' : 'option_text_un_selected'}>
					<p>{text}</p>
				</TextComponent>
			</div>
		</>
	);
};

export default SalesForceCheckBox;
